import { Skeleton } from '@/components/UI/Skeleton'
import type { ReactNode } from 'react'

type Props = {
  /** 表示するスタンプ数（デフォルト: 9 = 3行 × 3列） */
  stampCount?: number
  /**
   * スケルトンのアニメーション（シマー）有無（デフォルト: true）。
   * ロック中シートなど「ローディングではない」用途では false にして静的に見せる。
   */
  animate?: boolean
  /**
   * プレースホルダーの上に重ねて表示するオーバーレイ。
   * ロック中シートの施錠アイコン・開放日時などを `absolute inset-0` で重ねる用途。
   * ルートは `relative overflow-hidden` のためカード全体を覆える。
   */
  overlay?: ReactNode
}

/**
 * StampSheet の形状に合わせたプレースホルダー。
 * スタンプシートのローディング中、およびロック中（開放前）シートの表示に使用する。
 */
export function StampSheetSkeleton({ stampCount = 9, animate = true, overlay }: Props) {
  return (
    <div className="rounded-lg px-4 py-6 border border-[#cbcbce] relative overflow-hidden bg-white">
      {/* シート名 */}
      <div className="flex justify-center">
        <Skeleton variant="text" width="50%" height={20} animate={animate} />
      </div>

      {/* 達成状況 */}
      <div className="mt-1 flex justify-end">
        <Skeleton variant="text" width="35%" height={14} animate={animate} />
      </div>

      {/* スタンプグリッド（3列）。gap-y-4 が行間を担う（StampSheet 本体と揃える） */}
      <div className="mt-4 grid grid-cols-3 place-items-center gap-y-4">
        {Array.from({ length: stampCount }).map((_, i) => (
          <div
            // biome-ignore lint/suspicious/noArrayIndexKey: 静的なプレースホルダー行のため index を key に使用
            key={i}
            data-testid="stamp-sheet-placeholder-stamp"
            className="flex flex-col items-center gap-1 w-full"
          >
            <Skeleton variant="circle" width={60} animate={animate} />
            <Skeleton variant="text" width="70%" height={12} animate={animate} />
          </div>
        ))}
      </div>

      {overlay}
    </div>
  )
}
